export default "__VITE_ASSET__C3Sden65__"